<ng-container *ngIf="form.get(fieldName) || fieldControl as f; else errore">
  <label *ngIf="fieldLabel" [for]="fieldName" class="form-label">{{ fieldLabel }}</label>
  <custom-number-input
    *ngIf="showSeparators; else plainInput"
    [textEnd]="textEnd"
    [class.is-invalid]="f.errors"
    [class.is-warned]="!!warnings"
    [formControl]="f | toFormControl"
    [disabled]="readonlyField"
    [maxIntegerDigits]="maxIntegerDigits"
    [maxFractionDigits]=maxFractionDigits
    [prefix]="prefix"
    [suffix]="suffix"
    [id]="fieldName"
    [placeholder]="placeholder"
  ></custom-number-input>
  <ng-template #plainInput>
    <input
      *ngIf="!readonlyField; else readonlyInput"
      type="number"
      class="form-control"
      [class.is-invalid]="f.errors"
      [class.is-warned]="!!warnings"
      [formControl]="f | toFormControl"
      [id]="fieldName"/>
    <ng-template #readonlyInput>
      <input
        type="number"
        [attr.disabled]="true"
        class="form-control"
        [ngClass]="{'text-end': textEnd}"
        [class.is-invalid]="f.errors"
        [class.is-warned]="!!warnings"
        [value]="f.value"
        [formControl]="f | toFormControl"
        [id]="fieldName"
        [attr.placeholder]="placeholder">
    </ng-template>
  </ng-template>
  <div *ngIf="fieldDescription" class="form-text">{{ fieldDescription }}</div>
  <field-warnings [warnings]="warnings"></field-warnings>
  <div field-errors [control]="f"></div>
</ng-container>
<ng-template #errore>
  Il campo <i>{{ fieldName }}</i> non esiste
</ng-template>

